// SEO und GEO: Beschreibungen je Seite, Firmendaten für strukturierte Daten.
// Wird im Browser (components/Seo.jsx) und beim Build (tools/seo/prerender-head.mjs) gelesen.
// Nur relative Imports mit .js Endung (Version 3), damit Node die Datei weiterhin direkt laden kann.
import { V3_PAGES } from "../v3/pages.js";
import { V3_SEO_TITLES, V3_SEO_DESCRIPTIONS, EN_READY } from "../v3/seo.js";
// v4/seo.js bleibt im Repo (ältere V4 Arbeitsfassung), wird für die finale V4 Linie nicht mehr geladen.

export const SITE = {
    url: "https://parto-solution.com",
    name: "Parto",
    legalName: "Parto Solution GmbH",
    logo: "https://parto-solution.com/parto-logo.png",
    image: "https://parto-solution.com/media/og/parto-og.jpg",
    email: "info@parto-solution.com",
    phone: "+49 5971 9629031",
    address: { street: "Stadtforst 3", zip: "48432", city: "Rheine", region: "Nordrhein-Westfalen", country: "DE" },
    founders: ["Artur Schlee", "Paul Seemann"],
    register: "Amtsgericht Osnabrück HRB 221871",
    vatId: "DE334703195",
    sameAs: ["https://hubparto.com/", "https://partoassets.com/", "https://www.buyparto.com/"],
    // Marken von Parto (BuyParto = Sofortankauf)
    brands: [
        { name: "HubParto", url: "https://hubparto.com/" },
        { name: "Parto Assets", url: "https://partoassets.com/" },
        { name: "BuyParto", url: "https://www.buyparto.com/" },
    ],
};

// Seiten, die indexiert werden sollen (ohne Sprachpräfix). Reihenfolge = Sitemap.
export const ROUTES = [
    "/",
    "/how-it-works",
    "/solutions",
    "/solutions/surplus-excess",
    "/solutions/mro-spare-parts",
    "/solutions/obsolete-slow-moving",
    "/solutions/plant-closures",
    "/solutions/sell-industrial-inventory",
    "/solutions/sell-surplus-inventory",
    "/solutions/sell-machinery-equipment",
    "/solutions/plant-closures-restructuring",
    "/references",
    "/company",
    "/sustainability",
    "/brands",
    "/location",
    "/quality",
    "/services",
    "/industries",
    "/news",
    "/ecosystem",
    "/partners",
    "/careers",
    "/contact",
    "/impressum",
    "/datenschutz",
    "/llm-info",
];

export const DESCRIPTIONS = {
    de: {
        "/": "Parto ist Ihre Komplettlösung für industriellen Überbestand: Ersatzteile, Altbestände und Maschinen, von der Bestandsliste bis zur Auszahlung alles aus einer Hand. Sitz in Rheine.",
        "/how-it-works": "So arbeitet Parto: Bestandsliste senden, bewerten, umsetzen, abrechnen. Alles aus einer Hand, mit voller Kontrolle für Sie und ohne Vorkosten.",
        "/solutions": "Überbestände, Ersatzteile, veraltete Teile oder ein ganzes Werk: Wählen Sie Ihre Ausgangslage und sehen Sie, wie Parto aus Ihrem Bestand wieder Kapital macht.",
        "/solutions/surplus-excess": "Überbestand verkaufen statt lagern. Parto bringt überschüssige Industrieteile Teil für Teil zum Marktpreis zurück in den Markt.",
        "/solutions/mro-spare-parts": "MRO Ersatzteillager entlasten, ohne Risiko für die Produktion. Parto prüft mit Ihrer Instandhaltung, was bleibt und was verkauft wird.",
        "/solutions/obsolete-slow-moving": "Langsamdreher und abgekündigte Industrieteile verkaufen. Parto findet Käufer, die genau diese Teile für ältere Anlagen suchen.",
        "/solutions/plant-closures": "Werksschließung oder Standortaufgabe: Parto erfasst, verkauft und räumt Maschinen, Teile und Material zum festen Termin.",
        "/solutions/sell-industrial-inventory": "Industriebestand verkaufen: SPS, Umrichter, Antriebe oder ein ganzes Lager. Parto prüft, findet Käufer und wickelt den Verkauf ab.",
        "/solutions/sell-surplus-inventory": "Überbestand verkaufen: Zu viel bestellt, Projekt beendet, Produkt umgestellt. Parto verkauft Ihren Überschuss, Sie bekommen Geld und Fläche zurück.",
        "/solutions/sell-machinery-equipment": "Gebrauchte Maschinen und Anlagen verkaufen: einzelne Maschine, ganze Linie oder Ersatzteile. Bewertung, Verkauf, Abbau und Abtransport.",
        "/solutions/plant-closures-restructuring": "Standort oder Werk räumen bei Schließung, Umzug oder Umbau. Parto erfasst alles, verkauft es und übergibt die Halle pünktlich.",
        "/references": "Referenzen und typische Projekte von Parto: Werksräumungen, Ersatzteillager, Überbestände und abgekündigte Teile. Kundenstimmen und Partner.",
        "/company": "Über Parto Solution GmbH aus Rheine: wer wir sind, wofür wir stehen und wie wir Industrieteilen einen zweiten Markt eröffnen.",
        "/sustainability": "Nachhaltigkeit bei Parto: Industrieteile bekommen einen zweiten Lebenszyklus statt Schrott. Was keinen Käufer findet, wird fachgerecht recycelt, mit Nachweis.",
        "/brands": "Die Markenfamilie von Parto: HubParto für den Onlineverkauf, Parto Assets für Ausschreibungen und BuyParto für den Sofortankauf. Alles aus einer Hand.",
        "/location": "Parto Solution GmbH in Rheine: Sitz, Lager, Aufbereitung und Versand. Von hier aus bringt Parto Industriebestände weltweit an den Markt.",
        "/quality": "Qualität und Sicherheit bei Parto: Eigentum bleibt bei Ihnen, nichts ohne Ihre Freigabe, versicherte Lagerung, Anonymität gegenüber Käufern.",
        "/services": "Alle Leistungen der Parto Komplettlösung: Bestandsaufnahme, Bewertung, Abholung, Lagerung, Verkauf über alle Kanäle, Sofortankauf, Werksräumung, Recycling und Abrechnung.",
        "/industries": "Parto für Ihre Branche: Maschinenbau, Automobil, Chemie, Lebensmittel, Energie und Logistik. Überbestand und Ersatzteile verkaufen, alles aus einer Hand.",
        "/news": "Presse und Neuigkeiten von Parto: Meldungen, Fachartikel, Pressematerial und Pressekontakt.",
        "/ecosystem": "Vier Wege in den Markt: Einzelverkauf über HubParto, Ausschreibungen über Parto Assets, Sofortankauf über BuyParto und ein Netzwerk aus Händlern und Partnern.",
        "/partners": "Partner werden: Händler, Einkäufer, Logistik und Verwertung arbeiten mit Parto zusammen und bekommen Zugang zu geprüfter Industrieware.",
        "/careers": "Karriere bei Parto in Rheine: offene Stellen in Vertrieb, Kundenbetreuung und Onlinehandel. Wir suchen Menschen, die anpacken.",
        "/contact": "Kontakt zu Parto: Bestand anfragen, Verkauf im Auftrag oder Sofortankauf über BuyParto, Abwicklung besprechen oder Partner werden. Alles aus einer Hand.",
        "/impressum": "Impressum der Parto Solution GmbH, Stadtforst 3, 48432 Rheine.",
        "/datenschutz": "Datenschutzerklärung der Parto Solution GmbH.",
        "/llm-info": "Strukturierte Informationen über Parto Solution GmbH für KI Systeme und Suchmaschinen.",
    },
    en: {
        "/": "Parto is your complete solution for industrial surplus stock: spare parts, legacy stock and machinery, from inventory list to payout, everything from one source. Based in Rheine, Germany.",
        "/how-it-works": "How Parto works: send your inventory list, assess, execute, settle. Everything from one source, with full control for you and no upfront cost.",
        "/solutions": "Surplus stock, spare parts, obsolete parts or a whole plant: choose your situation and see how Parto turns your inventory into money.",
        "/solutions/surplus-excess": "Sell surplus stock instead of storing it. Parto brings excess industrial parts back to the market, part by part at market price.",
        "/solutions/mro-spare-parts": "Free up your spare parts store without risking production. Parto works with your maintenance team on what stays and what is sold.",
        "/solutions/obsolete-slow-moving": "Sell obsolete and discontinued industrial parts. Parto finds buyers who need exactly these parts for older machines.",
        "/solutions/plant-closures": "Plant closure or site exit: Parto captures, sells and clears machines, parts and material by a fixed date.",
        "/solutions/sell-industrial-inventory": "Sell industrial inventory: PLCs, drives, motors or a whole warehouse. Parto reviews, finds buyers and handles the sale.",
        "/solutions/sell-surplus-inventory": "Sell surplus inventory: ordered too much, project ended, product changed. Parto sells your surplus and you get money and space back.",
        "/solutions/sell-machinery-equipment": "Sell used machinery and equipment: a single machine, a whole line or spare parts. Assessment, sale, dismantling and transport.",
        "/solutions/plant-closures-restructuring": "Clear a site or plant for closure, relocation or conversion. Parto captures everything, sells it and hands over the hall on time.",
        "/references": "Parto references and typical projects: plant clearances, spare parts stores, surplus stock and discontinued parts. Reviews and partners.",
        "/company": "About Parto Solution GmbH from Rheine, Germany: who we are, what drives us and how we give industrial parts a second market.",
        "/sustainability": "Sustainability at Parto: industrial parts get a second life cycle instead of becoming scrap. Parts without a buyer are recycled professionally, with proof.",
        "/brands": "The Parto brand family: HubParto for online sales, Parto Assets for tenders and BuyParto for instant purchase. Everything from one source.",
        "/location": "Parto Solution GmbH in Rheine, Germany: head office, warehouse, refurbishment and shipping. From here Parto brings industrial inventory to market worldwide.",
        "/quality": "Quality and security at Parto: ownership stays with you, nothing without your approval, insured storage, anonymity towards buyers.",
        "/services": "All services of the Parto complete solution: inventory review, assessment, collection, storage, sale through every channel, instant purchase, plant clearance, recycling and settlement.",
        "/industries": "Parto for your industry: machine building, automotive, chemicals, food, energy and logistics. Sell surplus stock and spare parts, everything from one source.",
        "/news": "Press and news from Parto: announcements, articles, press material and press contact.",
        "/ecosystem": "Four routes to market: single sales through HubParto, tenders through Parto Assets, instant purchase through BuyParto and a network of dealers and partners.",
        "/partners": "Become a partner: dealers, buyers, logistics and recycling companies work with Parto and get access to checked industrial goods.",
        "/careers": "Careers at Parto in Rheine, Germany: open roles in sales, customer success and e commerce. We look for people who get things done.",
        "/contact": "Contact Parto: sale on your behalf or instant purchase through BuyParto, discuss handling or become a partner. Everything from one source.",
        "/impressum": "Imprint of Parto Solution GmbH, Stadtforst 3, 48432 Rheine, Germany.",
        "/datenschutz": "Privacy policy of Parto Solution GmbH.",
        "/llm-info": "Structured information about Parto Solution GmbH for AI systems and search engines.",
    },
};

// ---------- Version 1 „Original neu gestaltet“: eigene Adressen, Titel und Beschreibungen ----------
const V1_SOLUTIONS = [
    "/solutions/surplus-excess", "/solutions/mro-spare-parts", "/solutions/obsolete-slow-moving", "/solutions/plant-closures",
    "/solutions/sell-industrial-inventory", "/solutions/sell-surplus-inventory", "/solutions/sell-machinery-equipment", "/solutions/plant-closures-restructuring",
];
const V1_ROLES = ["supply-chain-procurement", "maintenance-mro", "operations", "finance"];
export const ROUTES_V1 = [
    "/", "/infrastructure", "/solutions", ...V1_SOLUTIONS,
    "/by-role", ...V1_ROLES.map((r) => `/by-role/${r}`),
    "/insights", "/insights/references", "/insights/articles", "/insights/news",
    "/company", "/sustainability", "/ecosystem", "/partners", "/careers", "/contact", "/impressum", "/datenschutz", "/llm-info",
];

export const TITLES_V1 = {
    de: {
        "/": "Industrielle Überbestände in Wert verwandeln",
        "/infrastructure": "Infrastruktur",
        "/solutions": "Solutions",
        "/by-role": "Für Ihre Rolle",
        "/by-role/supply-chain-procurement": "Supply Chain und Einkauf",
        "/by-role/maintenance-mro": "Instandhaltung und MRO",
        "/by-role/operations": "Operations",
        "/by-role/finance": "Finanzen",
        "/insights": "Insights",
        "/insights/references": "Referenzen",
        "/insights/case-studies": "Case Studies",
        "/insights/articles": "Fachartikel",
        "/insights/news": "News und Presse",
        "/company": "Unternehmen",
        "/sustainability": "Nachhaltigkeit und Kreislaufwirtschaft",
        "/ecosystem": "Ökosystem",
        "/partners": "Partner",
        "/careers": "Karriere",
        "/contact": "Kontakt",
        "/impressum": "Impressum",
        "/datenschutz": "Datenschutz",
        "/llm-info": "Informationen für KI Systeme",
    },
    en: {
        "/": "Turning industrial surplus into value",
        "/infrastructure": "Infrastructure",
        "/solutions": "Solutions",
        "/by-role": "By role",
        "/by-role/supply-chain-procurement": "Supply chain and procurement",
        "/by-role/maintenance-mro": "Maintenance and MRO",
        "/by-role/operations": "Operations",
        "/by-role/finance": "Finance",
        "/insights": "Insights",
        "/insights/references": "References",
        "/insights/case-studies": "Case studies",
        "/insights/articles": "Articles",
        "/insights/news": "News and press",
        "/company": "Company",
        "/sustainability": "Sustainability and circular economy",
        "/ecosystem": "Ecosystem",
        "/partners": "Partners",
        "/careers": "Careers",
        "/contact": "Contact",
        "/impressum": "Imprint",
        "/datenschutz": "Privacy",
        "/llm-info": "Information for AI systems",
    },
};

const V1_DESC = {
    de: {
        "/": "Parto ist die Komplettlösung für industrielle Überbestände: Erfassen, bewerten, lagern, verkaufen und abrechnen aus einer Hand, mit voller Kontrolle für Sie.",
        "/infrastructure": "Die Parto Infrastruktur: Daten, Lager, Kanäle und Abwicklung greifen ineinander, damit freigegebene Bestände geordnet an den Markt kommen.",
        "/by-role": "Parto aus Ihrer Perspektive: was Einkauf, Instandhaltung, Operations und Finanzen von einer Komplettlösung für Überbestände haben.",
        "/by-role/supply-chain-procurement": "Für Supply Chain und Einkauf: Überbestände senken, Kapital freisetzen und Transparenz über Bestände schaffen, ohne zusätzlichen Aufwand.",
        "/by-role/maintenance-mro": "Für Instandhaltung und MRO: Ersatzteillager entlasten, ohne die Versorgung der Anlagen zu gefährden.",
        "/by-role/operations": "Für Operations: Flächen frei machen und Werksumbauten oder Schließungen geordnet abwickeln.",
        "/by-role/finance": "Für Finanzen: gebundenes Kapital zurückholen, Restwerte erzielen und jede Position nachvollziehbar abrechnen.",
        "/insights": "Insights von Parto: Referenzen, Fachartikel und News rund um Überbestände und den zweiten Lebenszyklus industrieller Assets.",
        "/insights/references": "Referenzen von Parto: Kundenstimmen, Partner und typische Projekte rund um Überbestände und Werksräumungen.",
        "/insights/case-studies": "Case Studies von Parto. Weitere Beiträge folgen.",
        "/insights/articles": "Fachartikel von Parto zu Überbeständen, Altbeständen, MRO Ersatzteilen und dem zweiten Lebenszyklus industrieller Assets.",
        "/insights/news": "News und Presse von Parto: Meldungen aus dem Unternehmen und dem Parto Ecosystem.",
        "/company": "Parto Solution GmbH aus Rheine: wer wir sind, wofür wir stehen und wie wir Industriebeständen einen zweiten Lebenszyklus geben.",
        "/ecosystem": "Das Parto Ecosystem: HubParto, Parto Assets, BuyParto und ein Netzwerk aus Händlern und Partnern bringen Industriebestände weltweit an den Markt.",
        "/partners": "Partner von Parto werden: Händler, Einkäufer, Logistik und Verwertung erhalten Zugang zu geprüfter Industrieware.",
    },
    en: {
        "/": "Parto is the complete solution for industrial surplus: capture, assess, store, sell and settle from one source, with full control for you.",
        "/infrastructure": "The Parto infrastructure: data, warehouse, channels and handling work together so released inventory reaches the market in an orderly way.",
        "/by-role": "Parto from your perspective: what procurement, maintenance, operations and finance gain from a complete solution for surplus stock.",
        "/by-role/supply-chain-procurement": "For supply chain and procurement: reduce surplus, free up capital and gain transparency over inventory without extra effort.",
        "/by-role/maintenance-mro": "For maintenance and MRO: free up spare parts stores without putting plant supply at risk.",
        "/by-role/operations": "For operations: free up space and handle plant conversions or closures in an orderly way.",
        "/by-role/finance": "For finance: release tied up capital, realise residual value and settle every position transparently.",
        "/insights": "Insights from Parto: references, articles and news on surplus stock and the second life cycle of industrial assets.",
        "/insights/references": "Parto references: client reviews, partners and typical projects around surplus stock and plant clearances.",
        "/insights/case-studies": "Parto case studies. More to follow.",
        "/insights/articles": "Articles by Parto on surplus stock, obsolete inventory, MRO spare parts and the second life cycle of industrial assets.",
        "/insights/news": "News and press from Parto: announcements from the company and the Parto ecosystem.",
        "/company": "Parto Solution GmbH from Rheine, Germany: who we are, what we stand for and how we give industrial inventory a second life cycle.",
        "/ecosystem": "The Parto ecosystem: HubParto, Parto Assets, BuyParto and a network of dealers and partners bring industrial inventory to market worldwide.",
        "/partners": "Become a Parto partner: dealers, buyers, logistics and recycling companies get access to checked industrial goods.",
    },
};
// Gemeinsame Seiten übernehmen die Beschreibung aus Version 2
export const DESCRIPTIONS_V1 = {
    de: { ...DESCRIPTIONS.de, ...V1_DESC.de },
    en: { ...DESCRIPTIONS.en, ...V1_DESC.en },
};

// Version 4 (Korrektur Chef 29.10.2026): eigene Beschreibungen, wo der Text von Version 3 abweicht
const V4_DESCRIPTIONS_DE = {
    // 30.10.2026 (U-02): Pressematerial vorerst ausgeblendet
    "/wissen/news-presse": "Neuigkeiten und Presse von Parto Solution: aktuelle Meldungen und Pressekontakt rund um den wirtschaftlichen Umgang mit industriellen Beständen.",
    "/solutions/marktzugang": "Marktzugang für industrielle Bestände: Parto vermarktet Komponenten und Maschinen über interne und externe Plattformen, im Inland, Ausland und weltweit.",
};

// Passende Daten je Version
// Version 3: Adressen aus src/v3/pages.js, Titel (vollständig, schon mit „| Parto Solution“) und Beschreibungen aus src/v3/seo.js
export const ROUTES_V3 = V3_PAGES;
export const TITLES_V3 = V3_SEO_TITLES;
export const DESCRIPTIONS_V3 = V3_SEO_DESCRIPTIONS;
export const V3_EN_READY = EN_READY;

export const seoFor = (v) => {
    // Version 4 nutzt dieselbe Sitemap und dieselben Meta Texte wie Version 3
    if (String(v) === "4") return { routes: ROUTES_V3, descriptions: { ...DESCRIPTIONS_V3, de: { ...DESCRIPTIONS_V3.de, ...V4_DESCRIPTIONS_DE } }, titles: TITLES_V3 };
    if (String(v) === "3") return { routes: ROUTES_V3, descriptions: DESCRIPTIONS_V3, titles: TITLES_V3 };
    return String(v) === "1"
        ? { routes: ROUTES_V1, descriptions: DESCRIPTIONS_V1, titles: TITLES_V1 }
        : { routes: ROUTES, descriptions: DESCRIPTIONS, titles: null };
};

// Pfade, die nicht in den Index sollen
export const NOINDEX = [/^\/admin/];

export const organizationLd = (lang = "de") => ({
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": `${SITE.url}/#organization`,
    name: SITE.name,
    legalName: SITE.legalName,
    url: SITE.url,
    logo: SITE.logo,
    image: SITE.image,
    email: SITE.email,
    telephone: SITE.phone,
    vatID: SITE.vatId,
    founder: SITE.founders.map((n) => ({ "@type": "Person", name: n })),
    address: {
        "@type": "PostalAddress",
        streetAddress: SITE.address.street,
        postalCode: SITE.address.zip,
        addressLocality: SITE.address.city,
        addressRegion: SITE.address.region,
        addressCountry: SITE.address.country,
    },
    areaServed: ["DE", "EU"],
    knowsAbout: lang === "en"
        ? ["industrial surplus inventory", "MRO spare parts", "obsolete industrial parts", "used machinery", "plant closures", "second life cycle for industrial parts", "instant purchase of industrial stock"]
        : ["Industrielle Überbestände", "Ersatzteile Instandhaltung", "Abgekündigte Industrieteile", "Gebrauchte Maschinen", "Werksschließungen", "Verwertung von Industriebeständen", "Sofortankauf von Industriebeständen"],
    sameAs: SITE.sameAs,
    brand: SITE.brands.map((b) => ({ "@type": "Brand", name: b.name, url: b.url })),
});

// Version 4. organizationLd bleibt für die Versionen 1 bis 3 unverändert.
export const organizationLdV4 = (lang = "de") => ({
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": `${SITE.url}/#organization`,
    name: SITE.name,
    legalName: SITE.legalName,
    url: SITE.url,
    logo: SITE.logo,
    image: SITE.image,
    email: SITE.email,
    telephone: SITE.phone,
    vatID: SITE.vatId,
    description: lang === "en"
        ? "[Parto organises the commercial sale and recovery of industrial stock on the customer's behalf. Parto does not buy the submitted stock. Ownership stays with the customer during the sale process.]"
        : "Parto organisiert die wirtschaftliche Vermarktung und Verwertung industrieller Bestände im Kundenauftrag. Parto kauft die eingereichten Bestände nicht selbst an. Das Eigentum bleibt während der Vermarktung beim Kunden.",
    founder: SITE.founders.map((n) => ({ "@type": "Person", name: n })),
    address: {
        "@type": "PostalAddress",
        streetAddress: SITE.address.street,
        postalCode: SITE.address.zip,
        addressLocality: SITE.address.city,
        addressRegion: SITE.address.region,
        addressCountry: SITE.address.country,
    },
    areaServed: ["DE", "EU"],
    knowsAbout: lang === "en"
        ? ["Asset Intelligence", "Asset Operations", "Market Execution", "Resource Recovery", "industrial surplus stock", "MRO spare parts", "obsolete industrial parts", "plant closures"]
        : ["Asset Intelligence", "Asset Operations", "Market Execution", "Resource Recovery", "Industrielle Überbestände", "MRO und Ersatzteile", "Veraltete Industriebestände", "Standortschließungen"],
    sameAs: ["https://hubparto.com/", "https://partoassets.com/"],
    brand: [
        { "@type": "Brand", name: "HubParto", url: "https://hubparto.com/" },
        { "@type": "Brand", name: "Parto Assets", url: "https://partoassets.com/" },
    ],
});

export const websiteLd = (lang = "de") => ({
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": `${SITE.url}/#website`,
    url: SITE.url,
    name: SITE.name,
    inLanguage: lang === "en" ? "en" : "de",
    publisher: { "@id": `${SITE.url}/#organization` },
});

export const faqLd = (faq) => ({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faq.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
});

export const breadcrumbLd = (items) => ({
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({ "@type": "ListItem", position: i + 1, name: it.name, item: it.url })),
});
